module.exports = __webpack_public_path__ + "images/sprites/ui/icon_expand_arrow_bk_7bf7ce1a47981bb8f2e13a0a29bae6d4.png";